import { cn } from "@newxsystems/shared";
import { StratosCardLink } from "../StratosCardLink/StratosCardLink";
import { StratosMedia } from "../StratosMedia/StratosMedia";
import { StratosRichText } from "../StratosRichText/StratosRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => (
  <div
    className={cn("grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2", columns[columnCount || 3])}
  >
    {items.map((item, index) => (
      <StratosCardLink className="overflow-visible border-0" key={index} link={item.cardLink}>
        <StratosMedia
          aspectRatio={imageAspectRatio || "16:9"}
          imageClassName="transition-transform duration-300 ease-out group-hover:scale-[1.015]"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
        <div className="relative -mt-8 mx-4 rounded-[20px] bg-cloud-white p-5 shadow-[0_18px_42px_-32px_rgb(16_23_34/0.55)]">
          <h3 className="font-stratos-display text-2xl font-bold leading-tight transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <StratosRichText
              className="mt-3 text-base text-steel md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
      </StratosCardLink>
    ))}
  </div>
);

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
